import { post } from "../util/http";
import Vue from "vue";
import Vuex from "vuex";
import { format } from "@/util/time";
import { decodePicture } from "@/util/decodePicture";
Vue.use(Vuex);
import i18n from "@/locales";
import { aesDecode } from "@/util/aes";

export const store = new Vuex.Store({
  state: {
    showDia: false,
    header: 0,
    // 路由加载状态
    routeLoading: false,
    liveRoomData: {},
    timMessageReceived: [],
    isEnterPrivateChat: false,
    enterUserChatFlag: 1,
    userChatId: 0,
    userChatName: "",
    userMessageList: [],
    isLoadingMore: false,
    noMoreMsg: false,
    groupMessageList: [],
    isFollowed: 0,
    groupInfo: [],
    fanGroup: [],
    anchorId: 0,
    anchorInfo: {},
    fansGroups: [],
    chatList: [],
    /** 直播间群聊发消息时写入，getChatList 返回时合并，避免被接口覆盖导致用户中心列表不同步 */
    localGroupLastMessage: {},
    privateMessageList: [],
    quizPrompt: {},
    timGuessList: [],
    toast: [],
    deleteMessageId: null,
    disabledSendMsg: false,
    giftAnimation: {},
    isContinuousGift: false,
    continuousGift: [],
    playerStatus: 1,
    hot: 0,
    colorfulTextColor: ["#113BD0", "#E41EB1", "#FF6B00"],
    loginRepData: {},
    messageList: [],
    count: 0,
    welcomeMsg: [],
    isTimReady: false,
    liveNotice: "",
    liveAdContact: [],
    liveAdContactMain: "",
    isCheckinDialog: false,
    isNeedRefresh: false,
    ticketAnchor: {},
    ticketPayDialog: false,
    ticket: 0,
    userBackpack: [],
    props: {
      speaker: 0,
      colorful1: 0,
      colorful2: 0,
      colorful3: 0,
    },
    isLiveLogout: false,
    wrapHeight: "",
    isNavShow: false,
    navCategory: {
      firstId: 0,
      secondId: 0,
      name: "全部直播",
    },
    isHomePage: false,
    showLogin: false,
    showBarrage: true,
    userInfo: {
      id: 0,
      diamond: 0,
      gold: 0,
    },
    userAsset: {},
    isShow: false,
    showDynamicRel: false,
    categories: [],
    appConfig: {},
    defaultAvatar: require("./moren@2x.png"),
    pageConfig: {},
    loginType: "login",
    tourist: {},
    tim: null,
    unReadCount: 0,
    msgLiveAnchor: {},
    isOpenAnimation: true,
    locales: [
      {
        code: "zh-CN",
        name: "CN",
      },
      {
        code: "en-US",
        name: "EN",
      },
    ],
    locale: LOCALE,
    isClone: false,
    liveBarrage: [],
    userState: 12,
    isLiving: false,
    chips: [],
    /** 直播间是否展示群聊：0 不展示，1 展示（来自 getCommonConfig 的 config.group_chat_toggle） */
    group_chat_toggle: 1,
    gifts: JSON.parse(sessionStorage.getItem("gifts") || "{}"),
    giftList: [],
    chatConfig: {
      total_trigger_banned: 1,
      continue_trigger_banned: 1,
      continue_trigger_num: 2,
      id: 1,
      link_set: 0,
      num_msg_count: 2,
      single_msg_num_length: 3,
      speak_rate: 1,
      toggle_continue_trigger: 1,
      toggle_link_set: 1,
      toggle_num_msg_count: 1,
      toggle_single_msg: 1,
      toggle_speak_rate: 1,
      toggle_total_trigger: 1,
      total_trigger: 3,
    },
    matchDetailData: {
      modified: [],
      received: {
        textLive: "",
        scoreLive: "",
        statsLive: "",
      },
    },
    isChehui: "",

    // 新增状态
    unreadCountMap: {}, // 以会话ID为key的未读数映射 {[conversationKey]: unreadCount}
    lastChatListLoadTime: 0, // 最后加载聊天列表的时间
    chatListDirty: false, // 标记聊天列表是否需要刷新
    messageProcessingLock: false, // 消息处理锁，防止重复处理
  },
  getters: {
    // 计算总未读数（优化版）
    unreadTotal(state) {
      let total = 0;
      Object.values(state.unreadCountMap).forEach((count) => {
        if (typeof count === "number") {
          total += count;
        }
      });
      if (total > 99) {
        return "99+";
      } else {
        return total;
      }
    },

    // 获取会话的唯一key
    getConversationKey: (state) => (item) => {
      if (!item) return "";
      if (item.type === 0) return `0_${item.fans_group_id}`;
      if (item.type === 2) return `2_${item.group_id}`;
      if (item.type === 3) return `3_${item.group_id}`;
      if (item.type === 1) return `1_${item.anchor_id}`;
      return "";
    },

    userState(state) {
      return state.userState;
    },
    appConfig(state) {
      return state.appConfig;
    },
    isLiving(state) {
      return state.isLiving;
    },
    chips(state) {
      return state.chips;
    },
    gifts(state) {
      return state.gifts;
    },
    chatConfig(state) {
      return state.chatConfig;
    },

    // 获取特定会话的未读数
    getUnreadByKey: (state) => (conversationKey) => {
      return state.unreadCountMap[conversationKey] || 0;
    },
  },
  mutations: {
    // 初始化聊天列表（修改版：保留现有的实时未读数）
    initChatList(state, list) {
      state.chatList = list;
      state.lastChatListLoadTime = Date.now();

      // 创建新的未读映射，但保留现有的实时未读数
      const unreadMap = { ...state.unreadCountMap }; // 先复制现有的
      
      list.forEach((item) => {
        if (item.anchor_id !== state.userInfo.id) {
          const key = `${
            item.type === 0 ? "0" : item.type === 2 ? "2" : item.type === 3 ? "3" : "1"
          }_${
            item.type === 0
              ? item.fans_group_id
              : item.type === 2 || item.type === 3
              ? item.group_id
              : item.anchor_id
          }`;

          // 重要：如果本地已经有实时更新的未读数，优先使用它
          // 否则使用后端返回的未读数
          if (unreadMap[key] === undefined) {
            unreadMap[key] = item.unread_num || 0;
          }
          
          // 确保item中的unread_num也更新为最新的值
          const currentUnread = unreadMap[key];
          const index = list.findIndex(i => {
            if (i.type !== item.type) return false;
            if (i.type === 0) return i.fans_group_id === item.fans_group_id;
            if (i.type === 2 || i.type === 3) return i.group_id === item.group_id;
            if (i.type === 1) return i.anchor_id === item.anchor_id;
            return false;
          });
          
          if (index !== -1 && list[index].unread_num !== currentUnread) {
            list[index].unread_num = currentUnread;
          }
        }
      });

      // 更新 state
      state.chatList = list;
      state.unreadCountMap = unreadMap;
    },

    // 更新特定聊天项
    updateChatListItem(state, { item, index }) {
      if (index >= 0 && index < state.chatList.length) {
        // 更新前检查是否需要更新未读数
        const oldItem = state.chatList[index];
        const key = `${
          item.type === 0 ? "0" : item.type === 2 ? "2" : item.type === 3 ? "3" : "1"
        }_${
          item.type === 0
            ? item.fans_group_id
            : item.type === 2 || item.type === 3
            ? item.group_id
            : item.anchor_id
        }`;
        
        // 如果item的unread_num和当前unreadCountMap不一致，更新item
        const currentUnread = state.unreadCountMap[key] || 0;
        if (item.unread_num !== currentUnread) {
          item = { ...item, unread_num: currentUnread };
        }
        
        state.chatList.splice(index, 1, item);
      } else {
        // 如果是新会话，添加到列表开头
        state.chatList.unshift(item);
      }

      // 注意：这里不再自动更新unreadCountMap，因为unreadCountMap是主数据源
      // unreadCountMap应该通过专门的updateUnreadCount mutation来更新
    },

    // 删除聊天项
    removeChatListItem(state, index) {
      if (index >= 0 && index < state.chatList.length) {
        const item = state.chatList[index];
        const key = `${
          item.type === 0 ? "0" : item.type === 2 ? "2" : item.type === 3 ? "3" : "1"
        }_${
          item.type === 0
            ? item.fans_group_id
            : item.type === 2 || item.type === 3
            ? item.group_id
            : item.anchor_id
        }`;
        delete state.unreadCountMap[key];
        state.chatList.splice(index, 1);
      }
    },

    // 清空聊天列表（登录时调用）
    clearChatList(state) {
      state.chatList = [];
      state.unreadCountMap = {};
      state.localGroupLastMessage = {};
      state.privateMessageList = [];
      state.lastChatListLoadTime = 0;
      state.chatListDirty = false;
    },

    // 更新未读数（添加调试日志）
    updateUnreadCount(state, { conversationKey, count, type = "set" }) {
      if (!conversationKey) return;

      console.log('updateUnreadCount 调试:', {
        conversationKey,
        count,
        type,
        当前值: state.unreadCountMap[conversationKey]
      });

      if (type === "set") {
        state.unreadCountMap[conversationKey] = count;
      } else if (type === "add") {
        const current = state.unreadCountMap[conversationKey] || 0;
        state.unreadCountMap[conversationKey] = current + count;
      } else if (type === "reduce") {
        const current = state.unreadCountMap[conversationKey] || 0;
        state.unreadCountMap[conversationKey] = Math.max(0, current - count);
      } else if (type === "clear") {
        state.unreadCountMap[conversationKey] = 0;
      }
      
      console.log('更新后值:', state.unreadCountMap[conversationKey]);
    },

    // 批量更新未读数
    batchUpdateUnreadCount(state, updates) {
      updates.forEach(({ conversationKey, count, type = "set" }) => {
        this.updateUnreadCount({ conversationKey, count, type });
      });
    },

    // 标记聊天列表需要刷新
    markChatListDirty(state, dirty = true) {
      state.chatListDirty = dirty;
    },

    // 设置消息处理锁
    setMessageProcessingLock(state, locked) {
      state.messageProcessingLock = locked;
    },

    clearMatchLiveData(state) {
      state.matchDetailData.modified = [];
      state.matchDetailData.received = {
        textLive: "",
        scoreLive: "",
        statsLive: "",
      };
    },

    getMatchModified(state, event) {
      if (typeof event.data[0].payload.data == "undefined") {
        return false;
      }
      let payload_data = event.data[0].payload.data;
      if (payload_data.length <= 4) {
        return false;
      }
      if (payload_data.length > 4) {
        if (
          payload_data.indexOf("textLive") != -1 ||
          payload_data.indexOf("scoreLive") != -1 ||
          payload_data.indexOf("statsLive") != -1 ||
          payload_data.indexOf("lineupLive") != -1
        ) {
          state.matchDetailData.modified.push(event);
        }
      }
    },

    getMatchReceived(state, event) {
      event.data.forEach((item, index) => {
        if (typeof item.payload.data == "undefined") {
          return false;
        }
        let payload_data = item.payload.data;
        if (payload_data.length <= 4) {
          return false;
        }
        if (payload_data.indexOf("textLive") != -1) {
          state.matchDetailData.received.textLive = payload_data;
        }
        if (payload_data.indexOf("scoreLive") != -1) {
          state.matchDetailData.received.scoreLive = payload_data;
        }
        if (payload_data.indexOf("statsLive") != -1) {
          state.matchDetailData.received.statsLive = payload_data;
        }
      });
    },

    chehui(state, type) {
      state.isChehui = type;
    },

    showDiaHttp(state, type) {
      state.showDia = type;
    },

    changeHeader(state, num) {
      state.header = num;
    },

    changeLiveRoomData(state, obj) {
      state.liveRoomData = obj;
    },

    changeGiftList(state, arr) {
      state.giftList = arr;
    },

    changeTimMessageReceived(state, arr) {
      state.timMessageReceived = arr;
    },

    changeIsEnterPrivateChat(state, boo) {
      state.isEnterPrivateChat = boo;
    },

    changeEnterUserChatFlag(state, num) {
      state.enterUserChatFlag = num;
    },

    changeUserChatId(state, num) {
      state.userChatId = num;
    },

    changeUserChatName(state, str) {
      state.userChatName = str;
    },

    changeUserMessageList(state, arr) {
      state.userMessageList = arr;
    },

    changeIsLoadingMore(state, boo) {
      state.isLoadingMore = boo;
    },

    changeNoMoreMsg(state, boo) {
      state.noMoreMsg = boo;
    },

    changeGroupMessageList(state, arr) {
      state.groupMessageList = arr;
    },

    changeIsFollowed(state, num) {
      state.isFollowed = num;
    },

    changeGroupInfo(state, arr) {
      state.groupInfo = arr;
    },

    changeFanGroup(state, arr) {
      state.fanGroup = arr;
    },

    changeAnchorId(state, val) {
      state.anchorId = val;
    },

    changeAnchorInfo(state, obj) {
      state.anchorInfo = obj;
    },

    changeFansGroups(state, arr) {
      state.fansGroups = arr;
    },

    changeChatList(state, arr) {
      state.chatList = arr;
    },

    setLocalGroupLastMessage(state, { groupId, latest_msg, latest_msg_time }) {
      if (!groupId) return;
      const key = String(groupId);
      state.localGroupLastMessage = {
        ...state.localGroupLastMessage,
        [key]: { latest_msg, latest_msg_time },
      };
    },

    changePrivateMessageList(state, arr) {
      state.privateMessageList = arr;
    },

    removePrivateMessageBySeq(state, msgIdOrSeq) {
      if (msgIdOrSeq == null || msgIdOrSeq === "") return;
      const id = String(msgIdOrSeq);
      const idx = state.privateMessageList.findIndex((e) =>
        e.chatType === 3 ? false : String(e.seq ?? e.id ?? e.send_time ?? "") === id
      );
      if (idx !== -1) {
        state.privateMessageList.splice(idx, 1);
      }
    },

    pushPrivateMessageList(state, obj) {
      state.privateMessageList.push(obj);
    },

    changeQuizPrompt(state, obj) {
      state.quizPrompt = obj;
    },

    changeGuessList(state, arr) {
      state.timGuessList = arr;
      sessionStorage.setItem("timGuessList", JSON.stringify(arr));
    },

    pushToast(state, obj) {
      state.toast.push(obj);
    },

    changeDeleteMessageId(state, msgId) {
      state.deleteMessageId = msgId;
    },

    toggleDisabledSendMsg(state, boo) {
      state.disabledSendMsg = boo;
    },

    changeGiftAnimation(state, obj) {
      state.giftAnimation = obj;
    },

    toggleContinuousGift(state, boo) {
      state.isContinuousGift = boo;
    },

    changeContinuousGift(state, obj) {
      state.continuousGift[0] = obj;
    },

    changePlayerStatus(state, number) {
      state.playerStatus = number;
    },

    changeHot(state, number) {
      state.hot = number;
    },

    changeLoginRepData(state, obj) {
      console.error(obj, "sdsadsadsadsad");
      state.loginRepData = obj;
    },

    changeLastHitMessageList(state, val) {
      state.messageList[state.messageList.length - 1].hit = val;
    },

    deleteClearMessageList(state, chat_id) {
      state.messageList = state.messageList.filter((item) => item.id != chat_id);
    },

    deleteBannedMessageList(state, uid) {
      state.messageList = state.messageList.filter((item) => item.user_id != uid);
    },

    changeMessageList(state, arr) {
      state.messageList = Array.isArray(arr) ? arr : [];
    },

    pushMessageList(state, obj) {
      if (!Array.isArray(state.messageList)) {
        state.messageList = [];
      }
      state.messageList.push(obj);
    },

    upsertMessageList(state, obj) {
      if (!Array.isArray(state.messageList)) {
        state.messageList = [];
      }
      const index = state.messageList.findIndex((item) => {
        const sameMessageId = obj.messageId && item.messageId === obj.messageId;
        const sameSequence = obj.id != null && item.id != null && String(item.id) === String(obj.id);
        return sameMessageId || sameSequence;
      });
      if (index === -1) {
        state.messageList.push(obj);
      } else {
        Vue.set(state.messageList, index, { ...state.messageList[index], ...obj });
      }
    },

    addCount(state) {
      state.count = Math.random();
    },

    pushWelcomeMsg(state, obj) {
      if (state.welcomeMsg.length > 10) {
        state.welcomeMsg.shift();
      }
      state.welcomeMsg.push(obj);
    },

    toggleTimReady(state, boo) {
      state.isTimReady = boo;
    },

    changeLiveAd(state, str) {
      state.liveNotice = str;
    },

    changeLiveAdContact(state, arr) {
      state.liveAdContact = arr;
    },

    changeLiveAdContactMain(state, str) {
      state.liveAdContactMain = str;
    },

    toggleCheckinDialog(state, boo) {
      state.isCheckinDialog = boo;
    },

    toggleIsNeedRefresh(state, boo) {
      state.isNeedRefresh = boo;
    },

    changeTicketAnchor(state, obj) {
      state.ticketAnchor = obj;
    },

    toggleTicketPayDialog(state, boo) {
      state.ticketPayDialog = boo;
    },

    changeUserBackpack(state, arr) {
      state.userBackpack = arr;
    },

    changeTicket(state, num) {
      state.ticket = num || 0;
    },

    initialChatConfig(state, obj) {
      state.chatConfig = obj || {};
    },

    changeProps(state, obj) {
      state.props = obj;
    },

    changeWrapHeight(state, str) {
      state.wrapHeight = str;
    },

    toggleLiveLogout(state, boo) {
      state.isLiveLogout = boo;
    },

    toggleNavShow(state) {
      state.isNavShow = !state.isNavShow;
    },

    changeNavCategoryName(state, obj) {
      state.navCategory = {
        ...state.navCategory,
        ...obj,
      };
    },

    toggleHomePage(state, boo) {
      state.isHomePage = boo;
    },

    toggleShow(state) {
      state.isShow = !state.isShow;
    },

    toggClone(state) {
      state.isClone = !state.isClone;
    },

    toggleDynamicRel(state) {
      state.showDynamicRel = !state.showDynamicRel;
    },

    toggleBarrage(state) {
      state.showBarrage = !state.showBarrage;
    },

    toggleLogin(state) {
      console.error(41444)
      state.showLogin = !state.showLogin;
    },

    popupLogin(state) {
      state.userInfo = {
        id: "",
        diamond: 0,
        gold: 0,
      };
      localStorage.removeItem("userInfo");
      localStorage.removeItem("token");
      localStorage.removeItem("id");
      state.showLogin = true;
    },

    changeCate(state, data) {
      state.categories = data;
    },

    changeConfig(state, config) {
      state.appConfig = config;
      if (config && config.group_chat_toggle !== undefined) {
        state.group_chat_toggle = config.group_chat_toggle;
      }
    },

    changeUserInfo(state, info) {
      state.userInfo = info;
    },

    changeUserAsset(state, info) {
      state.userAsset = info;
    },

    changePageConfig(state, config) {
      state.pageConfig = config;
    },

    changeLoginType(state, type) {
      state.loginType = type;
    },

    changeGold(state, num) {
      state.userInfo.gold -= num;
    },

    changeTourist(state, data) {
      state.tourist = data;
    },

    changeIm(state, im) {
      state.tim = im;
    },

    changeUnder(state, count) {
      state.unReadCount = count;
    },

    changeMsgLive(state, anchor) {
      state.msgLiveAnchor = anchor;
    },

    toggleAnimation(state) {
      state.isOpenAnimation = !state.isOpenAnimation;
    },

    SET_LANG(state, locale) {
      if (state.locales.find((el) => el.code === locale)) {
        state.locale = locale;
      }
    },

    changeBarrage(state, payload) {
      state.liveBarrage = [payload];
    },

    setUserState(state, data = 0) {
      state.userState = data;
    },

    setIsLiving(state, data = false) {
      state.isLiving = data;
    },

    changeChips(state, data = []) {
      state.chips = data;
    },

    updateGifts(state, obj = {}) {
      const { key = "", data = {} } = obj;

      if (state.gifts[key]) {
        state.gifts[key] = {
          ...state.gifts[key],
          ...data,
        };
      } else {
        state.gifts[key] = data;
      }
      sessionStorage.setItem("GIFTS", JSON.stringify(state.gifts));
    },

    // 路由加载状态控制
    setRouteLoading(state, loading) {
      state.routeLoading = loading;
    },
  },

  actions: {
    handleNewMessage({ state, commit }, message) {
      console.error( state, commit,message)
      if (!message) return;

      const myUserId = String(state.userInfo?.id || "");

      // 跳过自己发送的消息
      if (message.flow === "out" || String(message.from) === myUserId) {
        return;
      }

      // 获取会话信息
      const conversationType = message.conversationType;
      let conversationKey = "";

      // 解析消息内容获取会话key
      // 使用字符串常量，避免 store 同步依赖 tim-js-sdk（约 600KB）
      if (conversationType === "C2C") {
        conversationKey = `1_${message.from}`;
      } else if (conversationType === "GROUP") {
        try {
          const payload = message.payload?.data || message.payload;
          const data = typeof payload === "string" ? JSON.parse(payload) : payload;
          if (data.type === "avChatSayRep" && data.resp?.group_id && data.resp.type === 3) {
            const groupId = String(data.resp.group_id);
            const groupType = data.resp.type === 0 ? "2" : data.resp.type === 3 ? "3" : "0";
            conversationKey = `${groupType}_${groupId}`;
          }
          if (data.type === "sayRep" && data.resp?.group_id && data.resp.type !== 3) {
            const groupId = String(data.resp.group_id);
            const groupType = data.resp.type === 0 ? "2" : data.resp.type === 3 ? "3" : "0";
            conversationKey = `${groupType}_${groupId}`;
          }
        } catch (e) {
          console.warn("解析群消息失败", e);
        }
      }

      if (!conversationKey) return;

      // 调试日志
      console.log('handleNewMessage 增加未读:', {
        conversationKey,
        当前未读: state.unreadCountMap[conversationKey] || 0,
        消息ID: message.ID || message.sequence
      });

      // 增加未读数
      commit("updateUnreadCount", {
        conversationKey,
        count: 1,
        type: "add",
      });
    },

    // 更新会话最后一条消息
    updateConversationLastMessage(
      { state, commit },
      { conversationKey, messageContent, senderId, groupId, timestamp }
    ) {
      // 找到对应的聊天项
      const index = state.chatList.findIndex((item) => {
        const itemType = item.type;
        const itemId =
          itemType === 0
            ? item.fans_group_id
            : itemType === 2 || itemType === 3
            ? item.group_id
            : item.anchor_id;
        const key = `${itemType}_${itemId}`;
        return key === conversationKey;
      });

      if (index !== -1) {
        const item = { ...state.chatList[index] };

        // 更新最后一条消息
        item.private_chat_latest_msg = {
          latest_msg: messageContent,
          latest_msg_time: timestamp,
        };

        // 更新未读数（如果当前不在这个会话中）
        if (!item.unread_num) {
          item.unread_num = 0;
        }

        commit("updateChatListItem", { item, index });

        // 重新排序（按时间降序）
        const sortedList = [...state.chatList].sort((a, b) => {
          const timeA = a.private_chat_latest_msg?.latest_msg_time || 0;
          const timeB = b.private_chat_latest_msg?.latest_msg_time || 0;
          return timeB - timeA;
        });

        commit("changeChatList", sortedList);
      } else {
        // 如果是新会话，需要从服务器获取完整信息
        // 这里可以延迟刷新，或者标记为需要刷新
        commit("markChatListDirty", true);
      }
    },

    // 添加 markConversationRead action
    async markConversationRead({ commit }, { conversationKey, type, id }) {
      if (!conversationKey) return;

      // 清除未读数
      commit("updateUnreadCount", {
        conversationKey,
        count: 0,
        type: "clear",
      });

      try {
        // 调用后端已读接口
        if (type === "private") {
          await post({
            url: "/api/mgrChat/read",
            data: { user_id: id },
          });
        } else if (type === "group") {
          await post({
            url: "/api/groupChat/read",
            data: { fans_group_id: id },
          });
        }
      } catch (error) {
        console.error("标记已读失败", error);
      }
    },

    getChatConfig({ commit }) {
      post({ url: "/api/live/chat_config" }).then((result) => {
        if (result.status === 200) {
          const res = result.data || {};

          if (res.status === 0) {
            commit("initialChatConfig", res.data);
          }
        }
      });
    },

    getUnderCount({ commit, state }) {
      if (!state.tim) return;
      state.tim.getConversationList().then((res) => {
        let count = 0;
        res.data.conversationList.forEach((item) => {
          if (item.conversationID === "C2Cadmin") {
            count = item.unreadCount;
          }
        });
        commit("changeUnder", count);
      });
    },

    receiveAllMessage({ commit, state }, msg) {
      msg.data.forEach((item) => {
        if (!item.payload.data) return;
        const data = JSON.parse(item.payload.data);
        console.log(data);
        if (data.Action === "AnchorStartLiveMessage") {
          commit("changeMsgLive", data.Data);
        }
        if (data.Action === "SystemMessage") {
          state.tim.getConversationList().then((res) => {
            let count = 0;
            res.data.conversationList.forEach((item) => {
              if (item.conversationID === "C2Cadmin") {
                count = item.unreadCount;
              }
            });
            commit("changeUnder", count);
          });
        }
      });
    },

    getUserInf1({ commit, dispatch }) {
      post({
        url: "/api/user/getUserInfo",
      }).then(({ data: { data } }) => {
        let { mobile = "" } = data;
        if (mobile) {
          let reg = /^(\d{3})\d{4}(\d{4})$/;
          data.formatPhone = mobile.replace(reg, "$1****$2");
        }
        commit("changeUserInfo", data);
        dispatch("getUserAsset");
      });
    },

    getUserAsset({ commit }) {
      post({
        url: "/api/user/getUserAsset",
      }).then(({ data: { data } }) => {
        commit("changeUserAsset", data);
      });
    },

    async getUserInfo({ commit, dispatch }) {
      const { data } = await post({
        url: "/api/user/getUserInfo",
      });
      if (data.status == 0) {
        let { mobile = "" } = data.data;
        if (mobile) {
          let reg = /^(\d{3})\d{4}(\d{4})$/;
          data.data.formatPhone = mobile.replace(reg, "$1****$2");
        }
        let keyValue = {
          ...JSON.parse(localStorage.getItem("userInfo")),
          diamond: data.data.diamond,
          gold: data.data.gold,
          mobile: data.data.mobile,
          formatPhone: data.data.formatPhone,
          ...data.data,
          level: Number(data.data.level) || 0,
          process: Number(data.data.process) || 0,
          remainder: Number(data.data.remainder) || 0,
        };
        localStorage.setItem("userInfo", JSON.stringify(keyValue));
        commit("changeUserInfo", { ...keyValue });
      }
    },

    toLogout() {
      post({
        url: "/api/user/logout",
      });
      localStorage.removeItem("userInfo");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("uid");
    },

    checkAnchorStatus({ state, commit }) {
      if (state.userInfo && state.userInfo.id) {
        post({ url: "/api/user/checkAnchorStatus" })
          .then(({ data: { data } }) => {
            let { is_anchor = 0, is_live = 0 } = data;
            if (is_live == 1) {
              commit("setIsLiving", true);
            } else {
              commit("setIsLiving", false);
            }
          })
          .catch((err) => {
            commit("setIsLiving", false);
            console.log("err: ", err);
          });
      } else {
        commit("setIsLiving", false);
      }
    },

    getUserBackpack({ state, commit }) {
      post({
        url: "/api/live/user_backpack",
        data: { user_id: state.userInfo.id },
      })
        .then(({ data: { data } }) => {
          let ticket;
          data.user_backpack?.forEach((item) => {
            if (item.type === 105) {
              ticket = item.quantity;
            }
          });
          commit("changeUserBackpack", data.user_backpack);
          commit("changeTicket", ticket);
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },

    getAnchorProfile({ state, commit }, anchorId) {
      if (!anchorId) return;
      post({
        url: "/api/groupChat/getAnchorProfile",
        data: { anchorId: anchorId },
      })
        .then(({ data: { data } }) => {
          commit("changeFansGroups", data.groups);
          commit("changeAnchorInfo", data.anchor_profile);
          commit("changeIsFollowed", data.is_attend);
          console.log(data);
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },

    async addToGroupChat({ state, commit, dispatch }, groupId) {
      const {
        data: { msg },
      } = await post({
        url: "/api/groupChat/addToGroupChat",
        data: { group_id: groupId },
      });
      return msg;
    },

    getGroupInfo({ state, commit }) {
      post({
        url: "/api/groupChat/getGroupInfo",
        data: { group_id: state.fanGroup.group_id },
      })
        .then(({ data: { data } }) => {
          commit("changeGroupInfo", data);
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },

    getGroupHistory({ state, commit, dispatch }, pageOrPayload = 1) {
      const opts =
        typeof pageOrPayload === "number"
          ? { page: pageOrPayload }
          : { page: pageOrPayload?.page ?? 1, silent: !!pageOrPayload?.silent };
      const page = opts.page;
      const silent = opts.silent;
      if (!silent) commit("changeIsLoadingMore", true);
      const groupId = state.fanGroup.group_id || state.fanGroup.fans_group_id;
      const groupIdStr = groupId != null && groupId !== "" ? String(groupId) : groupId;
      post({
        url: "/api/groupChat/getHistory",
        data: { group_id: groupIdStr, limit: 20, page: page },
      })
        .then(({ data: { data } }) => {
          let arr = data.FansGroupHistory;
          let noMoreMsg, timeLine;
          if (arr.length === 0) {
            noMoreMsg = {
              chatType: 3,
              content: "没有更多消息了",
            };
            arr = page === 1 ? [noMoreMsg] : [noMoreMsg, ...state.groupMessageList];
            commit("changeNoMoreMsg", true);
          } else {
            arr.forEach((e) => {
              if (e.uid === state.userInfo.id) {
                e.chatType = 1;
              } else {
                e.chatType = 2;
              }
            });
            timeLine = {
              chatType: 3,
              content: format(arr[0].send_time * 1000, "MM-dd hh:mm"),
            };
            if (page === 1) {
              arr = [timeLine, ...arr];
            } else {
              arr = [timeLine, ...arr, ...state.groupMessageList];
            }
          }

          if (!silent) commit("changeIsLoadingMore", false);
          commit("changeGroupMessageList", arr);
          dispatch("readGroupChat", groupIdStr);
        })
        .catch((err) => {
          console.log("err: ", err);
          if (!silent) commit("changeIsLoadingMore", false);
        });
    },

    // 修改 actions 中的 getChatList 方法
    getChatList({ state, commit }, { force = false } = {}) {
      // 如果不强制刷新且距离上次刷新时间较短，使用缓存
      const now = Date.now();
      if (!force && now - state.lastChatListLoadTime < 30000) {
        // 30秒内不重复请求
        console.log("getChatList: 使用缓存数据");
        return Promise.resolve(state.chatList);
      }

      // 如果有消息处理锁，等待一下
      if (state.messageProcessingLock) {
        return new Promise((resolve) =>
          setTimeout(() => {
            this.dispatch("getChatList", { force }).then(resolve);
          }, 200)
        );
      }

      commit("setMessageProcessingLock", true);
      console.log("getChatList: 发起请求");

      return post({
        url: "/api/groupChat/getChatList",
      })
        .then(({ data: { data } }) => {
          let list = data.chat_list || [];
          const local = state.localGroupLastMessage || {};

          list = list.map((item) => {
            if (item.type !== 0 && item.type !== 2) return item;
            const gid = String(item.fans_group_id ?? item.group_id ?? "");
            const localMsg = local[gid];
            if (!localMsg?.latest_msg_time) return item;
            const serverTime = item.private_chat_latest_msg?.latest_msg_time ?? 0;
            const serverMs = serverTime < 1e12 ? serverTime * 1000 : serverTime;
            if (localMsg.latest_msg_time <= serverMs) return item;
            return {
              ...item,
              private_chat_latest_msg: {
                ...(item.private_chat_latest_msg || {}),
                latest_msg: localMsg.latest_msg,
                latest_msg_time: localMsg.latest_msg_time,
              },
            };
          });

          commit("initChatList", list);
          commit("markChatListDirty", false);
          return list;
        })
        .catch((err) => {
          console.log("getChatList err: ", err);
          throw err;
        })
        .finally(() => {
          setTimeout(() => {
            commit("setMessageProcessingLock", false);
          }, 100);
        });
    },

    async readGroupChat({ state, commit, dispatch }, fans_group_id) {
      const {
        data: { msg },
      } = await post({
        url: "/api/groupChat/read",
        data: { fans_group_id: fans_group_id },
      });
      if (msg === "SUCCESS") {
        // 不再自动刷新列表，只更新未读数
        const conversationKey = `0_${fans_group_id}`;
        commit("updateUnreadCount", {
          conversationKey,
          count: 0,
          type: "clear",
        });
      }
    },

    // 修正的 onFollow action
    onFollow({ state, commit, dispatch }) {
      if (!state.userInfo.id) {
        commit("toggleLogin");
        return;
      }
      if (state.userInfo.id == state.anchorId) {
        commit("pushToast", "不能关注自己");
        return;
      }
      post({
        url: "/api/anchor/attentAnchor",
        data: {
          anchorid: state.anchorId,
        },
      }).then(({ data: { data } }) => {
        commit("changeIsFollowed", data.type);
        let text = data.type == 1 ? "关注成功" : "取消关注";
        commit("pushToast", text); // 只保留这一行
      });
    },

    getUserHistory({ state, commit, dispatch }, { uid, page = 1, silent = false }) {
      if (!silent) commit("changeIsLoadingMore", true);
      post({
        url: "/api/mgrChat/getHistory",
        data: { user_id: uid, limit: 20, page: page },
      })
        .then(({ data: { data } }) => {
          let arr = data.mgr_chat_history;
          let noMoreMsg, timeLine;
          if (arr.length === 0) {
            noMoreMsg = {
              chatType: 3,
              content: "没有更多消息了",
            };
            arr = [noMoreMsg, ...state.userMessageList];
            commit("changeNoMoreMsg", true);
          } else {
            arr.forEach((e) => {
              if (e.sender_uid === state.userInfo.id) {
                e.chatType = 1;
              } else {
                e.chatType = 2;
              }
            });
            timeLine = {
              chatType: 3,
              content: format(arr[0].send_time * 1000, "MM-dd hh:mm"),
            };
            if (page === 1) {
              arr = [...state.userMessageList, timeLine, ...arr];
            } else {
              arr = [timeLine, ...arr, ...state.userMessageList];
            }
          }

          if (!silent) commit("changeIsLoadingMore", false);
          commit("changeUserMessageList", arr);
          dispatch("readUserChat", uid);
        })
        .catch((err) => {
          console.log("err: ", err);
          if (!silent) commit("changeIsLoadingMore", false);
        });
    },

    async readUserChat({ state, commit, dispatch }, user_id) {
      const {
        data: { msg },
      } = await post({
        url: "/api/mgrChat/read",
        data: { user_id: user_id },
      });
      if (msg === "SUCCESS") {
        // 不再自动刷新列表，只更新未读数
        const conversationKey = `1_${user_id}`;
        commit("updateUnreadCount", {
          conversationKey,
          count: 0,
          type: "clear",
        });
      }
    },

    getPrivateHistory({ state, commit, dispatch }, pageOrPayload = 1) {
      const opts =
        typeof pageOrPayload === "number"
          ? { page: pageOrPayload }
          : { page: pageOrPayload?.page ?? 1, silent: !!pageOrPayload?.silent };
      const page = opts.page;
      const silent = opts.silent;
      if (!silent) commit("changeIsLoadingMore", true);
      post({
        url: "/api/privateChat/getRecordDetail",
        data: {
          device_id: localStorage.getItem("device_no"),
          anchor_id: state.anchorId,
          duration: 0,
          page: page,
          size: 20,
        },
      })
        .then(({ data: { data } }) => {
          let arr = data.msg_group || [];
          let noMoreMsg, timeLine;
          if (arr.length === 0) {
            noMoreMsg = {
              chatType: 3,
              content: i18n.t("live-room.no-more-msg"),
            };
            arr = page === 1 ? [noMoreMsg] : [noMoreMsg, ...state.privateMessageList];
            commit("changeNoMoreMsg", true);
          } else {
            timeLine = {
              chatType: 3,
              content: format(arr[0].send_time, "MM-dd hh:mm"),
            };
            if (page === 1) {
              arr = [timeLine, ...arr];
            } else {
              arr = [timeLine, ...arr, ...state.privateMessageList];
            }
            arr.forEach(async (e, index) => {
              if (e.sender_uid == state.anchorId) {
                e.chatType = 2;
              } else if (e.sender_uid !== state.anchorId && e.chatType !== 3) {
                e.chatType = 1;
              }
              if (e.img_url && e.loaded !== 1) {
                // let url = await decodePicture(e.img_url, index);
                // state.privateMessageList[index].img_url = url;
                // state.privateMessageList[index].loaded = 1;
              }
            });
          }
          console.error(arr);
          if (!silent) commit("changeIsLoadingMore", false);
          commit("changePrivateMessageList", arr);
          if (data.msg_group) {
            dispatch(
              "readPrivateChat",
              parseInt(data.msg_group[data.msg_group.length - 1].send_time / 1000)
            );
          }
        })
        .catch((err) => {
          if (!silent) commit("changeIsLoadingMore", false);
          console.log("err: ", err);
        });
    },

    readPrivateChat({ state, commit, dispatch }, latestMsgStamp) {
      post({
        url: "/api/privateChat/read",
        data: {
          device_id: localStorage.getItem("device_no"),
          anchor_id: state.anchorId,
          latest_msg_stamp: latestMsgStamp,
        },
      })
        .then(({ data }) => {
          // 不再自动刷新列表，只更新未读数
          const conversationKey = `1_${state.anchorId}`;
          commit("updateUnreadCount", {
            conversationKey,
            count: 0,
            type: "clear",
          });
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },
  },
});